import React, { useEffect, useState } from 'react'

import { PoweredByTruework } from '@frame/ui-primitives/powered-by-truework'

import defaultLogo from '@frame/images/default-logo.svg'
import { useStore } from '@frame/lib/stores/useStore'
import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

export function CobrandingLogo() {
  const cobrandingLogoUrl = useStore((state) => state.session?.configuration.cobranding.logo_url)
  const [src, setSrc] = useState<string>(defaultLogo)

  useEffect(() => {
    setSrc(cobrandingLogoUrl || defaultLogo)
  }, [cobrandingLogoUrl])

  const handleError = () => {
    setSrc(defaultLogo)
  }

  return (
    <div data-cy={DataAttribute.COBRANDING_LOGO}>
      <img
        src={src}
        className={cn('mx-auto mb-2 h-8 object-contain', cobrandingLogoUrl && 'mb-3')}
        onError={handleError}
        alt="Logo"
        aria-hidden="true"
      />
      <PoweredByTruework />
    </div>
  )
}
